import { DocsMenuState } from '.';
import { DocsPortalStore } from '../../AppStore';
import { createSelector } from '@reduxjs/toolkit';

export const selectDocsMenuState = (state: DocsPortalStore) => state.docsMenu;

export const selectOpenSections = createSelector(
  [selectDocsMenuState],
  (docsMenuState: DocsMenuState) => docsMenuState.data.openedSections,
);
